import React, { useEffect, useState } from "react";
import {
  Box, FormControl, Select, MenuItem, Dialog, DialogTitle, DialogContent,
  DialogActions, TextField, Button, Tooltip,
} from "@mui/material";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import axios, { getActiveWorkspace, setActiveWorkspace } from "../axiosConfig";

const NEW = "__new__";

export default function WorkspaceSwitcher() {
  const [workspaces, setWorkspaces] = useState([]);
  const [active, setActive] = useState(getActiveWorkspace());
  const [dialogOpen, setDialogOpen] = useState(false);
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get("/api/workspaces")
      .then((r) => {
        if (r.data?.success) setWorkspaces(r.data.data || []);
      })
      .catch(() => {});
  }, []);

  const switchTo = (value) => {
    if (value === NEW) {
      setDialogOpen(true);
      return;
    }
    setActiveWorkspace(value);
    setActive(value);
    window.location.reload(); // refetch everything under the new workspace
  };

  const autoSlug = (n) =>
    n.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 64);

  const create = async () => {
    setError("");
    const finalSlug = (slug || autoSlug(name)).trim();
    if (!name.trim() || finalSlug.length < 2) {
      setError("Name required (slug auto-derives, min 2 chars).");
      return;
    }
    try {
      const r = await axios.post("/api/workspaces", { slug: finalSlug, name: name.trim() });
      if (!r.data?.success) {
        setError(r.data?.error || "Failed to create");
        return;
      }
      setActiveWorkspace(finalSlug);
      window.location.reload();
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Tooltip title="Active workspace (strategy book) — scopes watchlists, history & trading">
          <WorkspacesIcon fontSize="small" sx={{ color: "text.secondary" }} />
        </Tooltip>
        <FormControl size="small" variant="standard">
          <Select
            value={workspaces.some((w) => w.slug === active) ? active : "default"}
            onChange={(e) => switchTo(e.target.value)}
            disableUnderline
            sx={{ fontSize: 13, color: "text.secondary", "& .MuiSelect-select": { py: 0.25 } }}
          >
            {workspaces.map((w) => (
              <MenuItem key={w.slug} value={w.slug} sx={{ fontSize: 13 }}>
                {w.name}
              </MenuItem>
            ))}
            <MenuItem value={NEW} sx={{ fontSize: 13, fontStyle: "italic" }}>
              + New workspace…
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>New workspace</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus margin="dense" label="Name" fullWidth value={name}
            onChange={(e) => { setName(e.target.value); setSlug(autoSlug(e.target.value)); }}
          />
          <TextField
            margin="dense" label="Slug (URL id)" fullWidth value={slug}
            onChange={(e) => setSlug(e.target.value)}
            helperText="lowercase letters, digits, hyphens"
          />
          {error && <Box sx={{ color: "error.main", fontSize: 13, mt: 1 }}>{error}</Box>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={create}>Create &amp; switch</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
